module.exports = __webpack_public_path__ + "0c60fb490adfbd442824d0687ba028ba.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/snd/yeah.mp3
// module id = 516
// module chunks = 0